import { useCallback, useState } from "react";

const getFirstItemFromMap = map => {
	const entries = map.entries();
	const item = entries.next().value;
	return item && item[1];
};

const getPriceBySeats = (priceBySeats, seats, originSeats) => {
	const price = priceBySeats.get(seats) || getFirstItemFromMap(priceBySeats);
	return price.betterOption
		? getPriceBySeats(priceBySeats, price.betterOption, originSeats || seats)
		: {
				...price,
				newSeats: price.newSeats != null ? price.newSeats : seats,
				originSeats: originSeats || seats,
		  };
};

const getDefaultSeatsValue = ({ newSeats }) => newSeats;

function useSeats(initialSeats, priceBySeats, getSeatsValue = getDefaultSeatsValue) {
	const [price, setPrice] = useState(() => getPriceBySeats(priceBySeats, initialSeats));

	const handleSetSeats = useCallback(
		value => {
			const priceItem = getPriceBySeats(priceBySeats, value);
			setPrice(priceItem);
		},
		[priceBySeats],
	);

	return [getSeatsValue(price), price, handleSetSeats];
}

export default useSeats;
